import React from "react";
import { Route, Routes } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute"; // Componente de protección para rutas privadas


import User from "@/pages/Users/userDash";
import Lawyer from "@/pages/Lawyers/lawDash";
import Admin from "@/pages/Admin/adminDash";

const PrivateRoutes = () => (
  <Routes>
    {/* Las rutas protegidas aquí deben envolver con <PrivateRoute> */}
    <Route element={<PrivateRoute allowedRoles={['client']} />}>
      <Route path="/dashboard/client" element={<User />} />
    </Route> 

     <Route element={<PrivateRoute allowedRoles={['lawyer', 'admin', 'client']}  />}>
      <Route path="/dashboard/lawyer" element={<Lawyer />} />
    </Route> 

    <Route element={<PrivateRoute allowedRoles={['admin']} />}>
      <Route path="/dashboard/admin" element={<Admin />} />
    </Route>   

    {/* por si quieres trabajar sin que las rutas esten protegidas descomenta lo de abajo */}
    {/* <Route path="/dashboard/client" element={<User />} />
    <Route path="/dashboard/lawyer" element={<Lawyer />} />
    <Route path="/dashboard/admin" element={<Admin />} />
    <Route path="/profile" element={<Page />} />     */}

  </Routes>
);

export default PrivateRoutes;
